import { InjectionToken } from '@angular/core';

export const CALLBACK_URL = new InjectionToken<string[]>('CALLBACK_URL');
